import Dashboard from './components/Dashboard'

export default [
    {
        path: '/',
        component: Dashboard,
        name: 'Dashboard',
    },
]
